import { render, staticRenderFns } from "./RadioQuestion.vue?vue&type=template&id=883b8eea&scoped=true"
import script from "./RadioQuestion.vue?vue&type=script&lang=js"
export * from "./RadioQuestion.vue?vue&type=script&lang=js"
import style0 from "./RadioQuestion.vue?vue&type=style&index=0&id=883b8eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883b8eea",
  null
  
)

export default component.exports